'use client'

import RichText from '@/components/RichText'
import HereLogoBcorp from '@/components/logos/HereLogoBcorp'
import FooterContactDetails from '@/components/FooterContactDetails'
import FooterNavLinks from '@/components/FooterNavLinks'
import NewsletterFull from '@/components/NewsletterFull'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { cn } from '@/lib/utils'

interface FooterProps {
	site?: any
	latestArticles?: any
}

export default function Footer({ site, latestArticles }: FooterProps) {
	const pathname = usePathname()
	const { newsletterHeader, newsletterCopy } = site || {}

	return (
		<>
			<Tickertape items={site?.tickertapeItems} />

			<div className={'w-full py-11 bg-blackBg text-white text-small leading-140'}>
				<div className={`site-wrapper site-grid px-site-margin`}>
					<div className="col-span-full md:col-span-9  grid gap-gutter grid-cols-12 md:grid-cols-9 footerFull:grid-cols-10">
						<div className="flex flex-col items-start md:justify-start col-span-5 sm:col-span-4 md:col-span-4">
							<HereLogoBcorp className="flex-none block w-full xs:w-[75%] md:w-[50%] md:pr-4 h-auto text-white mb-6 md:mb-12" />
							{site?.bcorpStatement && (
								<div className="block style-caption-small md:max-w-[320px] text-balance [&_a]:underlinexxx">
									<RichText content={site?.bcorpStatement} />
								</div>
							)}
						</div>

						<NewsletterFull
							version="footer"
							header={newsletterHeader}
							copy={newsletterCopy}
							className={cn(
								'col-span-full sm:col-span-7 sm:col-start-7 md:col-span-4 footerFull:!col-start-6 md:!col-start-5',
								'max-w-[400px] md:max-w-none',
								'pt-12 pb-4 sm:pt-0 sm:pb-0'
							)}
							linkClassName="text-white"
						/>

						{/* SITE NAV LINKS */}
						<FooterNavLinks
							site={site}
							pathname={pathname}
							className="col-span-4 col-start-9 md:col-span-2 md:col-start-8 footerFull:col-start-9"
						/>
					</div>

					{/* CONTACT DETAILS */}
					<FooterContactDetails site={site} className="col-span-full md:col-span-3 md:ml-auto" />

					<div className="col-span-full md:text-rightxxx style-caption-small mt-12">
						© {new Date().getFullYear()} Here Design
					</div>
				</div>
			</div>
		</>
	)
}

function Tickertape({ items }) {
	if (!items || items?.length === 0) return null
	const linkClass = 'w-auto pr-16 pb-[2px] flex-none flex items-end text-white hover:text-blue transition gap-4'
	const titleClass = 'relative top-[0.2em] md:top-[0.15em] md:text-[1.15em]'
	return (
		<>
			<div className="tickertape w-full overflow-hidden bg-blackBg text-white py-4 md:py-7 border-solid border-b border-white">
				<div className="w-full flex items-center">
					<div className="tickertape__content w-auto flex-none flex items-center">
						{items?.map((item) => {
							const slugPrefix = item?.link?._type === 'article' ? '/journal' : '/work'
							const url = `${slugPrefix}/${item?.link?.slug?.current}`
							return (
								<Link key={`${JSON.stringify(item)}_1`} href={url} className={linkClass}>
									<div className={`style-h4 font-new-sans text-white before:content-['#']`}>
										{item?.tag?.toLowerCase()}
									</div>
									<div className={`style-body`}>
										<span className={titleClass}>{item?.title}</span>
									</div>
								</Link>
							)
						})}
					</div>
					<div className="tickertape__content w-auto flex-none flex items-center">
						{items?.map((item) => {
							const slugPrefix = item?.link?._type === 'article' ? '/journal' : '/work'
							const url = `${slugPrefix}/${item?.link?.slug?.current}`
							return (
								<Link key={`${JSON.stringify(item)}_1`} href={url} className={linkClass}>
									<div className={`style-h4 font-new-sans text-white before:content-['#']`}>
										{item?.tag?.toLowerCase()}
									</div>
									<div className={`style-body`}>
										<span className={titleClass}>{item?.title}</span>
									</div>
								</Link>
							)
						})}
					</div>
				</div>
			</div>
		</>
	)
}
